import { PNLTXN_EMPTY_VALIDATION, PNLTXN_HIDE_EMPTY_VALIDATION, PNL_TRANSACTION_ERROR, PNL_TRANSACTION_HIDE_ERROR, PNL_TRANSACTION_REPORT, PNL_TRANSACTION_SHOW_SHIMMER, EDIT_SPLIT_TXN_LOADER, PNL_ORIGINAL_TXNS, PNL_ORIGINAL_TXNS_LOADER, STOCK_DETAILS_SUMMARY, } from "../../interfaces/Reports/iPNLTransactionReport";
import { SCREENSTATE } from "@frameworks/web/redux/interfaces/Reports/CoreReports/iHolding";
import { EREPORTSCREENSTATE } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
const initState = {
    data: {
        pnl: "",
        editableTransactionCount: 0,
        pnLTransactionDetails: [],
    },
    stockDetails: {
        isin: "",
        displayName: "",
        quantity: "",
        lastTradedPrice: "",
        change: "",
        changePercentage: "",
        scripIdentifier: "",
        description: "",
        exchange: "",
        editableCount: 0,
    },
    screenState: EREPORTSCREENSTATE.L1,
    goBackState: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    txnStatus: {
        error: null,
        isOpen: null,
    },
    emptyValidation: {
        icon: null,
        message: null,
    },
    showTransactionShimmer: false,
    editTXNShimmer: false,
    pnlOriginalTxns: [],
    orgTxnStatus: {
        error: null,
        isOpen: null,
    },
    orgTxnLoader: false,
};
const pnltranasactionReport = (state = initState, action) => {
    switch (action.type) {
        case PNL_TRANSACTION_REPORT:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case STOCK_DETAILS_SUMMARY:
            return Object.assign(Object.assign({}, state), { stockDetails: action.payload.stockDetails });
        case SCREENSTATE:
            return Object.assign(Object.assign({}, state), { screenState: action.payload.screenState, goBackState: action.payload.goBackState });
        case PNL_TRANSACTION_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: action.payload.errorData });
        case PNL_TRANSACTION_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: initState[action.errorType] });
        case PNLTXN_EMPTY_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyValidation: action.payload.emptyValidation });
        case PNLTXN_HIDE_EMPTY_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyValidation: initState.emptyValidation });
        case PNL_TRANSACTION_SHOW_SHIMMER:
            return Object.assign(Object.assign({}, state), { showTransactionShimmer: action.payload.showTransactionShimmer });
        case EDIT_SPLIT_TXN_LOADER: {
            return Object.assign(Object.assign({}, state), { editTXNShimmer: action.payload.editTXNShimmer });
        }
        case PNL_ORIGINAL_TXNS: {
            return Object.assign(Object.assign({}, state), { pnlOriginalTxns: action.payload.pnlOriginalTxns });
        }
        case PNL_ORIGINAL_TXNS_LOADER: {
            return Object.assign(Object.assign({}, state), { orgTxnLoader: action.payload.orgTxnLoader });
        }
        default:
            return Object.assign({}, state);
    }
};
export default pnltranasactionReport;
